import * as checkConstant from '@/api/biz/outbound/checkConstant';
import {i18n} from '@/api/i18n';

/**
 * 买卖宝订单标记
 * @param obCheckM
 * @returns {let}
 */
export const getBuyFlag = (obCheckM) => {
  let result = false;
  if (obCheckM.resource == checkConstant.YES_CODE) {
    result = (obCheckM.sendPay.substr(90, 1) != "1" && obCheckM.sendPay.substr(59, 3) == "009");
  }
  return result;
}

/**
 * 京东试用订单标记
 * @param obCheckM
 * @returns {boolean}
 */
export const getTryOut = (obCheckM) => {
  let result = false;
  if (obCheckM.resource == checkConstant.YES_CODE) {
    result = (obCheckM.sendPay.substr(9, 1) == "8");
  }
  return result;
}

/**
 * 海王星订单标记（外单）
 * @param obCheckM
 * @returns {boolean}
 */
export const getOutOrder = (obCheckM) => {
  let result = false;
  if (obCheckM.resource == checkConstant.YES_CODE) {
    result = (obCheckM.sendPay.substr(90, 1) == "1");
  }

  return result;
}

/**
 * 闪购标记
 * @param obCheckM
 * @returns {boolean}
 */
export const getquickBuyFlag = (obCheckM) => {
  let result = false;//闪购标记
  if (obCheckM.resource == checkConstant.YES_CODE) {
    if (obCheckM.sendPay.substr(13, 1) == "2" && obCheckM.sendPay.substr(55, 1) == "1") {
      result = true;
    }
  } else {
    //开放平台订单sendpay判断
    if (obCheckM.sendPay.substr(48, 1) == "1" && obCheckM.sendPay.substr(47, 1) == "1") {
      result = true;
    }
  }
  return result;
}

/**
 * 新通路标记
 * @param obCheckM
 * @returns {boolean}
 */
export const getXTLFlag = (obCheckM) => {
  let result = false;
  if (obCheckM.resource == checkConstant.YES_CODE) {
    result = (obCheckM.sendPay.substr(59, 3) == "014");
  }
  return result;
}

/**
 * 企业级用户标记
 * @param obCheckM
 * @returns {boolean}
 */
export const getEnterpriseUser = (obCheckM) => {
  let result = false;
  if (obCheckM.resource == checkConstant.YES_CODE) {
    let
    strTag = obCheckM.sendPay.substr(39, 1);
    if (strTag == "1" || strTag == "2" || strTag == "3" || strTag == "4") {
      result = true;
    }
  }
  return result;
}

/**
 * 1号店标记
 * @param obCheckM
 * @returns {boolean}
 */
export const getYihaodianSign = (obCheckM) => {
  let result = false;
  if (obCheckM.resource == checkConstant.YES_CODE) {
    let sendPay = obCheckM.sendPay;
    if (sendPay.Length < 62) {
      return false;
    }
    let strTag = sendPay.substr(59, 3);
    if (strTag == "034" || strTag == "035"
      || strTag == "036" || strTag == "037"
      || strTag == "038" || strTag == "039") {
      result = true;
    }
  }
  return result;
}

/**
 * 京准达标记（八种）
 * @param obCheckM
 * @returns {boolean}
 */
export const getJZDFlag = (obCheckM) => {
  let result = false;
  if (obCheckM.resource == checkConstant.YES_CODE) {
    let strTag = obCheckM.sendPay.substr(113, 5);
    if (strTag == "00010" || strTag == "00012"
      || strTag == "00013" || strTag == "00015"
      || strTag == "00016" || strTag == "00018"
      || strTag == "00030" || strTag == "00032") {
      result = true;
    }
  }
  return result;
}

/**
 * TDC京准达标记
 * @param obCheckM
 * @returns {boolean}
 */
export const getTDCJZDFlag = (obCheckM) => {
  let result = false;
  if (obCheckM.resource == checkConstant.YES_CODE) {
    let sendPay = obCheckM.sendPay;
    if (sendPay.Length < 118) {
      return false;
    }
    let strTag = sendPay.substr(113, 5);
    if (strTag == "00036") {
      result = true;
    }
  }
  return result;
}

/**
 * 港澳售订单标记
 * @param obCheckM
 * @returns {boolean}
 */
export const getGASFlag = (obCheckM) => {
  let result = false;
  if (obCheckM.resource == checkConstant.YES_CODE) {
    let strTag = obCheckM.sendPay.substr(107, 1);
    if (strTag == "1") {
      result = true;
    }
  }
  return result;
}

/**
 * 售后订单标记
 * @param obCheckM
 * @returns {boolean}
 */
export const getAfterSaleServicesFlag = (obCheckM) => {
  let result = false;
  if (obCheckM.resource == checkConstant.YES_CODE) {
    let afterSale = obCheckM.sendPay.substr(17, 1);
    if (afterSale == "1" || afterSale == "2") {
      result = true;
    }
  }
  return result;
}

/**
 * 企业客户标记
 * @param obCheckM
 * @returns {boolean}
 */
export const getEUser = (obCheckM) => {
  let result = false;
  if (obCheckM.resource == checkConstant.YES_CODE) {
    let eUser = obCheckM.sendPay.substr(39, 1);
    if ("1234567".Contains(eUser)) {
      result = true;
    }
  }
  return result;
}

/**
 * 城配订单标记
 * @param obCheckM
 * @returns {boolean}
 */
export const getCitySendFlag = (obCheckM) => {
  if (obCheckM.resource == checkConstant.SOURCE_ERP) {
    return obCheckM.sendPay.substr(145, 1) == "1";
  }
  return false;
}

/**
 * 全球售订单标记
 */
export const getGlobalSalesFlag = (obCheckM) => {
  if (obCheckM.resource == checkConstant.SOURCE_ERP) {
    return obCheckM.sendPay.substr(107, 1) == "2" || obCheckM.sendPay.substr(107, 1) == "3";
  }
  return false;
}

/**
 * 全球售合包订单标记
 * @param obCheckM
 * @returns {boolean}
 */
export const getGSCombinePackageFlag = (obCheckM) => {
  if (getGlobalSalesFlag(obCheckM)) {
    return obCheckM.sendPay.substr(123, 1) == "4";
  }
  return false;
}

/**
 * 是否自提
 * 0，表示【否】，不是自提
 * 1，表示【是】，是自提
 * @param obCheckM
 * @returns {*}
 */
export const getPickupStr = (obCheckM) => {
  if ("1".Equals(obCheckM.sendPay.substr(2, 1))) {
    return "HUB";
  }
  else {
    return "";
  }
}
